import { OnboardingHealthStatus } from '@sbv-clients/data-access-api';

/**
 * Enum for common colors.
 * @readonly
 * @enum {{name: string, value: OnboardingHealthStatus}}
 */
export const OnboardingHealthStatusConst = Object.freeze({
  READY: { name: 'Ready', value: OnboardingHealthStatus.NUMBER_0 },
  OTHER_MATCHES: {
    name: 'Other Matches',
    value: OnboardingHealthStatus.NUMBER_1,
  },
  DUPLICATE_PHONE: {
    name: 'Duplicate Phone',
    value: OnboardingHealthStatus.NUMBER_2,
  },
  DUPLICATE_LOGIN: {
    name: 'Duplicate Login',
    value: OnboardingHealthStatus.NUMBER_3,
  },
  INVALID_MOBILE_PHONE: {
    name: 'Invalid Mobile Phone',
    value: OnboardingHealthStatus.NUMBER_4,
  },
});
